/**
 * CircleProgress
 */

const TAU = 2 * Math.PI;

const CIRCLE_PROGRESS_DEFAULT_SIZE = 138;
const CIRCLE_PROGRESS_DEFAULT_THICKNESS = 9.1;
const CIRCLE_PROGRESS_DEFAULT_TRACK_COLOR = '#D9D9D9';
const CIRCLE_PROGRESS_DEFAULT_PROGRESS_COLOR = '#FFBE0B';
const CIRCLE_PROGRESS_DEFAULT_SUFFIX = null;

const CIRCLE_PROGRESS_START_ANGLE = Math.PI;

const CIRCLE_PROGRESS_LABEL_COLOR = '#111111';
const CIRCLE_PROGRESS_LABEL_FONT_SIZE = 40;
const CIRCLE_PROGRESS_LABEL_FONT_WEIGHT = 400;
const CIRCLE_PROGRESS_SUFFIX_FONT_SIZE = 16;
const CIRCLE_PROGRESS_SUFFIX_FONT_WEIGHT = 600;
const CIRCLE_PROGRESS_SUFFIX_DX = 4;
const CIRCLE_PROGRESS_SUFFIX_DY = 4;

export {
  TAU,
  CIRCLE_PROGRESS_DEFAULT_SIZE,
  CIRCLE_PROGRESS_DEFAULT_THICKNESS,
  CIRCLE_PROGRESS_DEFAULT_TRACK_COLOR,
  CIRCLE_PROGRESS_DEFAULT_PROGRESS_COLOR,
  CIRCLE_PROGRESS_DEFAULT_SUFFIX,
  CIRCLE_PROGRESS_START_ANGLE,
  CIRCLE_PROGRESS_LABEL_COLOR,
  CIRCLE_PROGRESS_LABEL_FONT_SIZE,
  CIRCLE_PROGRESS_LABEL_FONT_WEIGHT,
  CIRCLE_PROGRESS_SUFFIX_FONT_SIZE,
  CIRCLE_PROGRESS_SUFFIX_FONT_WEIGHT,
  CIRCLE_PROGRESS_SUFFIX_DX,
  CIRCLE_PROGRESS_SUFFIX_DY,
};
